export default "__VITE_ASSET__DJuxdH4w__"